import React from 'react'
import { Col, Row } from "reactstrap";

const NavigationButtons = ({ prevPage, nextPage, save }) => {
    return (
        <Row className="risk__buttons">
            <Col md={4} className="button back__button">
                {prevPage != null ? (
                    <button
                        className="btn btn-primary account__btn footer-btn"
                        onClick={() => {
                            save("prev");
                        }}>
                        Previous Section
                    </button>
                ) : (
                        <button
                            className="btn btn-primary account__btn footer-btn"
                            onClick={() => {
                                save("back");
                            }}>
                            Back to SRA Overview
                        </button>
                    )}
            </Col>
            <Col md={4} className="button middle__button">
                {prevPage == null || nextPage == null ? (
                    ""
                ) : (
                        <button
                            className="btn btn-primary account__btn footer-btn"
                            onClick={() => {
                                save("back");
                            }}
                        >
                            Back to SRA Overview
            </button>
                    )}
            </Col>
            <Col md={4} className="button next__button">
                {nextPage != null ? (
                    <button
                        className="btn btn-primary account__btn footer-btn"
                        onClick={() => {
                            save("next");
                        }}>
                        Next Section
                    </button>
                ) : (
                        <button
                            className="btn btn-primary account__btn footer-btn"
                            onClick={() => {
                                save("back");
                            }}>
                            Back to SRA Overview
                        </button>
                    )}
            </Col>
        </Row>
    )
}

export default NavigationButtons


// WEBPACK FOOTER //
// ./src/components/sra/components/NavigationButtons.js